var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 89.736 26.446 c -0.217 -4.79 -0.981 -8.063 -2.09 -10.925 c -1.129 -3.002 -2.901 -5.724 -5.189 -7.97 c -2.246 -2.288 -4.968 -4.061 -7.97 -5.193 c -2.862 -1.109 -6.132 -1.869 -10.925 -2.09 c -4.797 -0.217 -6.333 -0.271 -18.554 -0.271 S 31.251 0.05 26.454 0.268 c -4.797 0.221 -8.067 0.981 -10.929 2.094 C 12.519 3.49 9.8 5.263 7.551 7.551 C 5.263 9.8 3.49 12.519 2.362 15.525 c -1.109 2.862 -1.869 6.135 -2.09 10.925 C 0.05 31.251 0 32.783 0 45.004 C 0 57.228 0.05 58.76 0.271 63.558 c 0.217 4.79 0.977 8.063 2.09 10.925 c 1.129 3.002 2.901 5.724 5.189 7.97 c 2.246 2.288 4.968 4.061 7.97 5.189 c 2.862 1.113 6.132 1.873 10.925 2.09 c 4.797 0.217 6.333 0.271 18.554 0.271 s 13.756 -0.05 18.554 -0.271 c 4.79 -0.217 8.063 -0.977 10.925 -2.09 c 6.046 -2.339 10.824 -7.117 13.159 -13.159 c 1.113 -2.862 1.873 -6.135 2.09 -10.925 C 89.946 58.756 90 57.224 90 45.004 S 89.953 31.248 89.736 26.446 z M 81.634 63.189 c -0.202 4.39 -0.935 6.772 -1.547 8.358 c -1.513 3.925 -4.615 7.027 -8.54 8.54 c -1.586 0.617 -3.968 1.35 -8.358 1.547 c -4.743 0.217 -6.167 0.264 -18.185 0.264 s -13.442 -0.047 -18.185 -0.264 c -4.386 -0.202 -6.772 -0.935 -8.358 -1.547 c -1.955 -0.721 -3.723 -1.873 -5.174 -3.366 c -1.497 -1.45 -2.645 -3.219 -3.366 -5.174 c -0.617 -1.586 -1.35 -3.968 -1.547 -8.358 C 8.156 58.442 8.11 57.023 8.11 45.004 s 0.043 -13.442 0.26 -18.185 c 0.202 -4.39 0.935 -6.772 1.551 -8.358 c 0.721 -1.955 1.873 -3.723 3.366 -5.174 c 1.45 -1.497 3.219 -2.645 5.174 -3.366 c 1.586 -0.617 3.968 -1.35 8.358 -1.551 c 4.743 -0.213 6.167 -0.26 18.185 -0.26 l 0 0 c 12.015 0 13.438 0.047 18.185 0.264 c 4.39 0.202 6.772 0.935 8.358 1.547 c 1.955 0.721 3.723 1.873 5.174 3.366 c 1.497 1.45 2.645 3.219 3.366 5.174 c 0.617 1.586 1.35 3.968 1.551 8.358 c 0.217 4.747 0.264 6.167 0.264 18.185 S 81.852 58.442 81.634 63.189 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(135,135,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 21.893 c -12.764 0 -23.111 10.347 -23.111 23.111 S 32.236 68.115 45 68.115 s 23.111 -10.347 23.111 -23.111 S 57.764 21.893 45 21.893 z M 45 60.005 c -8.284 0 -15.001 -6.717 -15.001 -15.001 S 36.716 30.003 45 30.003 s 15.001 6.717 15.001 15.001 S 53.288 60.005 45 60.005 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(135,135,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.425 20.978 c 0 2.982 -2.42 5.399 -5.399 5.399 c -2.982 0 -5.399 -2.42 -5.399 -5.399 c 0 -2.982 2.42 -5.399 5.399 -5.399 S 74.425 17.999 74.425 20.978 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(135,135,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.674fa7ec83c29c5cd07524febcce7095.svg";
export { ForwardRef as ReactComponent };